/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/ku_IQ';
import DatePicker from './date-picker/ku_IQ';
import Pagination from './pagination/ku_IQ';
import TimePicker from './time-picker/ku_IQ';

export default {
  locale: 'ku-iq',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'MenuÃª peldanka',
    filterConfirm: 'Temam',
    filterReset: 'JÃª bibe',
    selectAll: 'HemÃ® hilbijÃªre',
    selectInvert: 'Hilbijartinan veguhere'
  },
  Modal: {
    okText: 'Temam',
    cancelText: 'Betal ke',
    justOkText: 'Temam'
  },
  Popconfirm: {
    okText: 'Temam',
    cancelText: 'Betal ke'
  },
  Transfer: {
    searchPlaceholder: 'LÃªgerÃ®n',
    itemUnit: 'tiÅt',
    itemsUnit: 'tiÅt'
  },
  Upload: {
    uploading: 'Bardike...',
    removeFile: 'PelÃª rabike',
    uploadError: 'Xeta barkirine',
    previewFile: 'PelÃª pÃªÅbibÃ®ne'
  },
  Empty: {
    description: 'AgahÃ® tune'
  }
};
